import { useRef } from "react"
import { Outlet } from "react-router-dom"
import { FormProvider } from "../../contexts/formContext"
import Footer from "../Footer"
import Header from "../Header"


export default function Wrapper() {
    const form = useRef()

    return (
        <FormProvider value={form}>
            <Header />
            <main className="main">
                <Outlet />
            </main>
            <Footer />
        </FormProvider>
    )
}